import React from "react";
import { Box, Typography, Paper, Grid, Button } from "@mui/material";
import "./house-rules.css"; // Custom CSS for additional styling

const HouseRules = ({ nextStep, prevStep }) => {
  return (
    <Box className='house-container'>
      <Paper className='house-info-container'>
        <Typography variant='h4' className='house-title' gutterBottom>
          House rules
        </Typography>

        <Typography variant='body1' className='content' paragraph>
          All houses have rules and when you move into Little Norway, the House rules will be explained to you by an
          adult. <br />
          If you don’t agree with a rule you can discuss it with the adults, and you can also be part of making rules
          within the home.
        </Typography>

        <Typography variant='body1' className='content' paragraph>
          We all understand that sometimes you may find things tricky and this may lead you to becoming upset or angry.
          <br />
          If this happens the adults will support you in any way they can. Adults will only ever physically hold you to
          prevent you from causing harm to yourself or others or if you are causing serious damage to property. <br />
          If this happens you will only be physically held for the shortest period necessary for you to calm down.
        </Typography>

        <Typography variant='body1' className='content' paragraph>
          If you do break a rule or cause damage you will receive something called a sanction.
        </Typography>
        <br />
        <Box className='bottom-content' mr={3} mb={8}>
          <Typography variant='body1' className='bottom-forms-content'>
            For example, if you cause <br /> damage in the home, you will <br />
            have to pay towards the cost <br />
            of fixing or replacing the <br />
            damaged item.
          </Typography>
        </Box>
      </Paper>
      <Box className='house-image-container'>
        <img src='./CYPImages/housenature.png' alt='Child illustration' className='house-image' />
      </Box>
      <Grid container justifyContent='flex-end' alignItems='center' spacing={15}>
        <Grid item>
          <Button type='button' variant='contained' color='primary' onClick={prevStep}>
            Previous
          </Button>
        </Grid>
        <Grid item></Grid>
        <Grid item>
          <Button type='button' variant='contained' color='primary' onClick={nextStep}>
            Next
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default HouseRules;
